module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-xs-12 app-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 app-header-user option_menu"
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 10px",
      "float": "right"
    }
  }, [(_vm.alloLogout) ? _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    staticStyle: {
      "margin": "0px 10px",
      "float": "right",
      "background-color": "#3b89cb"
    },
    attrs: {
      "to": "/logout",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("\n            ログアウト\n          ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    attrs: {
      "text": "オプション",
      "type": "primary btn  btn-xs btn-primary "
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.goToBrowserSettings
    }
  }, [_vm._v("ブラウザ設定")])])])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "padding": "8px",
      "font-size": "12px",
      "text-align": "end",
      "color": "#FFFFFF"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userCompany))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userDepartment))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userTeam))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userShimei))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userRole))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0px 0px 20px"
    }
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": "/menu",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("ホーム")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.device_embedded_information) == false,
      "tag": "button",
      "to": "/device_embedded_information",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("機器・組込情報")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　　証書　　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.certificateLinksDisabled
    }
  }, _vm._l((_vm.certificateLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.approval_history) == false,
      "tag": "button",
      "to": "/approval_history",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("申請承認")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　　棚卸　　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.inventoryLinksDisabled
    }
  }, _vm._l((_vm.inventoryLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.bulk_import) == false && _vm.checkHeaderUserPermission(_vm.acl.bulk_import2) == false,
      "tag": "button",
      "to": "/bulk_import",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("一括取込")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　ユーザ　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.masterUserDisabled
    }
  }, _vm._l((_vm.masterUserLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "管理・マスタ",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.configurationLinksDisabled
    }
  }, _vm._l((_vm.configurationLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " maintenance_menu",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "メンテナンス",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.maintenanceLinksDisabled
    }
  }, _vm._l((_vm.maintenanceLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1)])])]), _vm._v(" "), _c('information-modal', {
    attrs: {
      "tag": "prevendReturnMessage"
    }
  }), _vm._v(" "), _c('notice-modal', {
    attrs: {
      "stag": "processNoticeModalSchedule"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "float": "left",
      "padding": "20px 0px 0px 0px",
      "color": "#FFFFFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n          ソフトウェアライセンス管理\n          "), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("e-sma")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef0d086","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 1004
// module chunks = 0